(function ($) {
  $(document).ready(function () {
    if ($('.hm-image-text.view-shadow').length) {
      $('.hm-image-text.view-shadow').each(function () {
        const block = $(this);
        const media = $(block).find('.hm-image-text__media__wrapper');
        const content = $(block).find('.hm-image-text__content');

        if($(media).length && $(content).length) {
            function updateMediaHeight() {
                const windowWidth = $(window).width();
                const newHeight = $(content).innerHeight();

                if(windowWidth > 750) {
                    $(media).css('height', `${newHeight}px`);
                } else {
                    $(media).css('height', 'auto');
                }
            }

            updateMediaHeight();

            $(window).resize(function(){
                updateMediaHeight();
            });
        }
      });
    }
  });
})(jQuery);